module.exports = __webpack_public_path__ + "static/media/8OLA23.30293b62.jpg";